import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import WhatsappFloat from "@/components/site/WhatsappFloat";
import QuoteDialog from "@/components/site/QuoteDialog";
import SEO from "@/components/seo/SEO";

/**
 * Layout compartilhado das 3 páginas legais (Privacidade, Termos, Cookies).
 * Reaproveita o header/footer/estilo do resto do site — não é um visual
 * novo. `children` recebe o conteúdo já formatado (título/parágrafos).
 */
export const LegalPageLayout = ({ title, description, path, lastUpdated, children }) => {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <div className="App" data-testid="legal-page">
      <SEO title={title} description={description} url={path} type="article" />
      <Header onQuoteClick={() => setQuoteOpen(true)} />

      <main className="pt-[120px] lg:pt-[180px] pb-20 bg-white">
        <article className="mn-container max-w-3xl">
          <nav
            className="text-xs uppercase tracking-[0.2em] text-[var(--mn-dark)] flex items-center gap-2 mb-6"
            aria-label="breadcrumb"
          >
            <Link to="/" className="hover:text-[var(--mn-gold)]">Home</Link>
            <ChevronRight size={12} />
            <span className="text-[var(--mn-gold)]">{title}</span>
          </nav>

          <h1 className="mn-h-display text-[2.25rem] sm:text-[2.75rem] lg:text-[3rem] leading-[1.05]">
            {title}
          </h1>
          {lastUpdated && (
            <p className="mt-4 text-xs uppercase tracking-[0.18em] text-[var(--mn-dark)]/60">
              Última atualização: {lastUpdated}
            </p>
          )}

          <div className="mn-legal-content mt-10">{children}</div>
        </article>
      </main>

      <Footer />
      <WhatsappFloat />
      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} />
    </div>
  );
};

export default LegalPageLayout;
